import { render, staticRenderFns } from "./MealItemComboForm.vue?vue&type=template&id=4ff7ed0e&scoped=true"
import script from "./MealItemComboForm.vue?vue&type=script&lang=js"
export * from "./MealItemComboForm.vue?vue&type=script&lang=js"
import style0 from "./MealItemComboForm.vue?vue&type=style&index=0&id=4ff7ed0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7ed0e",
  null
  
)

export default component.exports